import React, { useCallback } from 'react'

import {
  Box,
  Text,
  Display,
  JustifyContent,
  FontWeight,
  Space,
  Icon,
  IconVariant,
  Color,
  AlignItems,
  withCitrusTheme,
  Link,
} from '@gousto-internal/citrus-react'
import { browserHistory } from 'react-router'

import routes from 'config/routes'

interface Props {
  portionsCount: string
}

const LinkWithoutUnderline = withCitrusTheme(Link, () => ({
  textDecoration: 'none',
  boxShadow: 'none',
}))

export const OrderBoxSize = ({ portionsCount }: Props) => {
  const onCTAClick = useCallback(() => {
    browserHistory.push(`${routes.client.deliveryDetails}`)
  }, [])

  return (
    <div data-testing="orderBoxSize">
      <Box display={Display.Flex} justifyContent={JustifyContent.SpaceBetween}>
        <Text fontWeight={FontWeight.Bold}>{`${portionsCount} person box`}</Text>
        <Box display={Display.Flex} alignItems={AlignItems.Center} onClick={onCTAClick}>
          <LinkWithoutUnderline>
            <Text size={1} color={Color.Secondary_400}>
              Edit
            </Text>
          </LinkWithoutUnderline>
          <Space size={1} direction="horizontal" />
          <Icon name="edit" variant={IconVariant.Actionable} size={5} />
        </Box>
      </Box>
    </div>
  )
}
